export const MEMBER_ELECTIONS_BASE_PATH = "/people/membership-services/member-elections" as const;
export const MEMBER_ELECTIONS_PENDING_PATH = "/people/membership-services/member-elections/pending" as const;
export const MEMBER_ELECTIONS_PAST_PATH = "/people/membership-services/member-elections/past" as const;
export const MEMBER_ELECTIONS_UPCOMING_DATES_PATH =
  "/people/membership-services/member-elections/upcoming-dates" as const;
